/* oxlint-disable constellation-content/numbers -- legal terms text, dates preserved verbatim */
const CicTacNew = `
<p>
 <strong>CIC Background Report Terms of Use</strong>
 <br/>
 <br/>
 You have requested to participate in the CIC’s® service (the “Service”). Your
 participation in the Service is subject to your acceptance of these Terms of Use. As
 used in these Terms of Use, “You” and “Your” refer to the subject Consumer
 or End User as defined below.
 <br/>
 <br/>
 “Consumer” means the individual who is the subject of the requested consumer
 report, on behalf of himself or herself and the Consumer’s heirs, beneficiaries,
 successors, and assigns.
 <br/>
 <br/>
 “End User” means the individual who or the entity that is requesting a consumer
 report pursuant to a permissible purpose pursuant to the Fair Credit Reporting Act
 (“FCRA”). If the End User is a corporation, limited liability company, or partnership,
 the individual agreeing below certifies, represents and warrants that he or she (1) is
 an agent, employee, officer, director, or authorized user, who is duly authorized to
 bind the entity set forth below, to the terms, conditions and certifications of this
 agreement, and (2) has direct knowledge of the facts certified in these Terms of Use.
 <br/>
 <br/>
 YOU MUST CAREFULLY READ AND AGREE TO ALL OF THE TERMS OF USE, INCLUDING
 THE ARBITRATION PROVISION, BEFORE ENROLLING IN THE SERVICE. As part of the
 Service, a Consumer may request a “Report Service”, which includes access to a copy
 of that Consumer’s housing court record and criminal information (“Background
 Screening Report”) and may authorize CIC to provide the Background Screening
 Report to an End User. Additional services may be included in the Service or Report
 Service (each referred to herein as a “Service”) in the future, and the registration and
 authentication information provided under this Agreement may be used in the
 provision of any such Service. Both Consumer and End User, if any, agree to the
 applicable Terms of Use set forth herein.
 <br/>
 <br/>
 These Terms of Use (“Terms of Use” or “Agreement”) apply to: (a) the Service; (b)
 interaction by any means between you and CIC regarding the Service; (c) your access
 to and use of the Service through the Zillow Rentals platform website located
 at www.zillow.com (“Service Website”); (d) your access to and use of resources, text,
 pictures, graphics, logos, button items, icons, images, works of authorship and other
 information and all revisions, modifications, and enhancements thereto (the
 “Content”); and (e) the resolution of all claims and disputes between us through
 arbitration. YOU AND CIC UNDERSTAND AND AGREE THAT THE ARBITRATION
 PROVISION CONTAINED IN SECTION 25 PROVIDES THAT WE EACH AGREE TO
 RESOLVE ANY DISPUTES BETWEEN US THROUGH BINDING ARBITRATION OR SMALL
 CLAIMS COURT TO THE FULLEST EXTENT PERMITTED BY LAW.
 <br/>
 <br/>
 YOUR ORDER OF, USE OF, AND ACCESS TO THE SERVICE, THROUGH THE SERVICE
 WEBSITE, THE CONTENT, AND THE RESOLUTION OF DISPUTES BETWEEN US ARE
 SUBJECT TO ALL TERMS OF USE CONTAINED HEREIN AND ALL APPLICABLE LAWS AND
 REGULATIONS. YOUR ORDER OF, ACCEPTANCE OF, USE OF, AND/OR ACCESS TO
 THE SERVICE, THROUGH THE SERVICE WEBSITE, AND/OR CONTENT CONSTITUTES
 YOUR AGREEMENT TO ABIDE BY EACH OF THE TERMS OF USE SET FORTH HEREIN,
 INCLUDING THE ARBITRATION PROVISION.
 <br/>
 <br/>
 By clicking below and by ordering any Service, you agree that CIC will provide you
 with the ordered Service in accordance with these Terms of Use.
 <br/>
 <br/>
 <strong>TERMS OF USE</strong>
 <br/>
 <br/>
 <strong>1. REGISTERING FOR THE SERVICE</strong>
 <br/>
 <br/>
 Once you register for CIC’s online Service, an access record will be created for you
 so that CIC can provide the Service and manage access as required by law. To
 complete your registration, you must provide us with your name, a valid address
 within the United States and an email address, and agree to be bound by these
 Terms of Use.
 <br/>
 <br/>
 Because the Service provides access to background information, you must provide a
 valid Social Security number, your current address, successfully pass authentication
 of your identity, provide true, accurate, complete and current information about
 yourself, and any other information requested by CIC or Zillow. By registering, you
 certify that you are eighteen (18) years of age or older. If any information you provide
 is untrue, inaccurate or not current, or if CIC has reasonable grounds to suspect that
 such information is untrue, inaccurate or not current, CIC, at its sole discretion, has
 the right to suspend or terminate your order of, use of, and/or access to any Service,
 and/or Content, and refuse all current or future orders of, use of, and/or access to,
 any Service, and/or Content, or suspend or terminate any portion thereof. Further,
 you agree that CIC will not be liable to you or any third party if CIC suspends or
 terminates your order of, use of, or access to any Service, or Content, or any portion
 thereof, for any reason.
 <br/>
 <br/>
 You access the Service through the Service Website, which is governed by the policies
 you accepted when creating your account on the Service Website. You agree to
 promptly notify CIC at compliance@CICReports.com of any unauthorized access to
 the Service, or any loss, theft or disclosure of your Service Website account
 credentials that could affect the security of the Service. Failure to provide such
 notice shall constitute a breach of this Agreement and shall constitute grounds for
 immediate termination of your account and the Service.
 <br/>
 <br/>
 Upon your request for the Service, and periodically thereafter, you will be asked
 to authenticate your identity in a manner which includes but is not limited to
 consumer report information, identifying information (e.g., name, address, social
 security number) that you provide and your responses to questions related to your
 consumer report information.
 <br/>
 <br/>
 <strong>2. REPORT SERVICE</strong>
 <br/>
 <br/>
 The Report Service allows you to establish connections with third parties and
 authorize or request that they authorize the sharing of the Background Screening
 Report. This Service will enable you as a Consumer to: (a) view your Background
 Screening Report ordered by you as a Consumer, and (b) authorize your
 Background Screening Report to be viewed by End Users; or if you are an End User,
 will enable you as an End User to view the Background Screening Report about a
 Consumer for which you have been authorized as an End User, for a limited time.
 <br/>
 <br/>
 When instructed by Consumer, Consumer is authorizing CIC to provide Consumer’s
 Background Screening Report to End Users with whom Consumer has successfully
 connected, for up to thirty days from the date of the Consumer’s most recent order
 for Background Screening Report (“Request Time”). Each End User may access the
 Consumer’s Background Screening Report and subsequently view a copy of the
 Consumer’s Background Screening Report during the remaining Request Time
 associated with the applicable order for Background Screening Report unless the
 Consumer terminates (deletes, cancels, removes or declines) an End User’s
 connection, access request or view capability. When an End User accesses the
 Consumer’s Background Screening Report, a copy of the Consumer’s Background
 Screening Report will be posted to the End User’s and Consumer’s
 accounts. <strong>Consumer acknowledges and agrees that CIC is not responsible for
 any actions or decisions made by any End Users or third parties with whom the
 Consumer has agreed to share Consumer’s Background Screening Report.</strong>
 <br/>
 <br/>
 If you are an End User, you may provide Zillow with the email addresses of
 consumers with whom you wish to connect. Zillow will send a connect request to the
 email address provided by you that will include your name, email address and any
 text you provide. Your name and email address will be available to all Consumers
 with whom you have or had a successful connection. You authorize Zillow to share
 your name and email address as described herein and required by the Report
 Service. You agree to refrain from using any unlawful, libelous, abusive, obscene,
 discriminatory or otherwise objectionable comments. You acknowledge and agree
 that CIC and Zillow are not responsible for your or any third party’s comments in user
 generated messages that are transmitted by the Report Service.
 <br/>
 <br/>
 <strong>3. REVIEW AND RECEIPT OF NOTICE TO USERS</strong>
 <br/>
 <br/>
 If you are an End User, by executing this Agreement, you acknowledge that you have
 read, understand and received the Notice to Users of Consumer Reports. The Notice
 to Users of Consumer Reports is located at <a href=“https://www.cicreports.com/FCRA-Notice-to-Users-of-Consumer-Reports”>https://www.cicreports.com/FCRA-Notice-to-Users-of-Consumer-Reports</a>.
 <br/>
 <br/>
 <strong>4. FCRA CERTIFICATIONS</strong>
 <br/>
 <br/>
 If you are the Consumer, you understand and certify that you are providing “written
 instructions” to CIC in accordance with the Fair Credit Reporting Act, 15 U.S.C. §1681
 et seq., as amended (“FCRA”) to access and use your consumer report for: (a)
 authenticating your identity; (b) providing you with a copy of your Background
 Screening Report; and (c) providing End Users with a copy of your Background
 Screening Report, upon your request or approval, and for the duration of your use
 of the Service.
 <br/>
 <br/>
 By requesting a copy of Consumer’s Background Screening Report, you acknowledge
 receipt of and certify that you have reviewed and fully understand the following
 statutory notices:
 <br/>
 Summary of Your Rights Under the Fair Credit Reporting Act (16 C.F.R. Part 601)
 located at <a href=“https://files.consumerfinance.gov/f/documents/bcfp_consumer-rights-summary_2018-09.pdf”>https://files.consumerfinance.gov/f/documents/bcfp_consumer-rights-summary_2018-09.pdf</a>
 <br/>
 <br/>
 Remedying the Effects of Identity Theft located at <a href=“https://www.ecfr.gov/current/title-12/chapter-X/part-1022/appendix-Appendix%20I%20to%20Part%201022”>https://www.ecfr.gov/current/title-12/chapter-X/part-1022/appendix-Appendix%20I%20to%20Part%201022</a>
 <br/>
 <br/>
 When requesting a Background Screening Report as an End User, End User
 represents and warrants that it has a permissible purpose and is requesting and
 using the Background Screening Report strictly in accordance with the FCRA and all
 applicable laws and regulations. End User agrees to and shall individually certify End
 User’s permissible purpose for access to a Background Screening Report on a
 consumer when requested by CIC. End User acknowledges that End User’s use of the
 Background Screening Report will be limited to only Renting/Leasing a Property and
 no other purpose, and End User will not request or use the Background Screening
 Report for any other purpose.
 <br/>
 <br/>
 NEITHER END USER NOR CONSUMER IS AUTHORIZED TO REQUEST OR RECEIVE
 CONSUMER INFORMATION FOR ANY USE NOT OTHERWISE IDENTIFIED HEREIN,
 INCLUDING BUT NOT LIMITED TO CREDIT REPAIR, MARKETING AND EMPLOYMENT.
 <br/>
 <br/>
 End User certifies that the use and related permissible purpose that End User
 designates is accurate. End User certifies that for each written instruction of a
 Consumer who is the subject of the Background Screening Report, such written
 instruction will expressly authorize End User to obtain the Background Screening
 Report and will contain at a minimum the Consumer’s name, address, and
 signature. End User agrees to a limited one-time use of each Consumer’s
 Background Screening Report solely for the permissible purpose for which it was
 provided.
 <br/>
 <br/>
 End User acknowledges and agrees that CIC, in its sole discretion, may require that
 End User confirms to have a permissible purpose to access the Services, and
 requests that End User complete an additional verification process to continue
 accessing the Services. End User understands that End User’s access to the Service
 may be suspended until such time as the End User’s review is complete and
 approved by CIC.
 <br/>
 <br/>
 END USER ACKNOWLEDGES THAT THE FCRA PROVIDES THAT ANY PERSON WHO
 KNOWINGLY AND WILLFULLY OBTAINS INFORMATION ON A CONSUMER FROM A
 CONSUMER REPORTING AGENCY UNDER FALSE PRETENSES SHALL BE FINED UNDER
 TITLE 18 OR IMPRISONED NOT MORE THAN TWO YEARS OR BOTH.
 <br/>
 <br/>
 <strong>5. FCRA DISPUTES OF BACKGROUND INFORMATION</strong>
 <br/>
 <br/>
 Accurate adverse information on Consumer’s background report cannot be changed.
 If Consumer believes that the Consumer’s CIC Background Screening Report contains
 inaccurate, incomplete, or information that is the result of fraud or human trafficking
 (“Disputed Information”), it is Consumer’s responsibility to contact CIC’s Consumer
 Relations Department to dispute such information. Consumer may at any time
 request a consumer file disclosure at no charge by contacting CIC’s Consumer
 Relations Department at CICReports.com/consumer-disputes or calling 888-316-
 4242 for assistance.
 <br/>
 <br/>
 If Consumer believes that the Consumer’s CIC Background Screening Report
 contains Disputed Information, Consumer agrees not to share or disclose
 Consumer’s Background Screening Report with anyone, except CIC.
 <br/>
 <br/>
 <strong>6. The Fair Housing Act and other fair housing laws</strong>
 <br/>
 <br/>
 The FHA prohibits discrimination on the basis of race, religion, color, national origin,
 sex, handicap (or disability), or familial status in the sale or rental of housing in the
 United States. A copy of the FHA is available at <a href=“https://www.justice.gov/crt/fair-housing-act-1”>https://www.justice.gov/crt/fair-housing-act-1</a>.
 End Users (including their staffs and management agents) should be familiar with the FHA generally and undertake affirmative steps to avoid violations
 of the FHA. The FHA prohibits both intentional discrimination and discrimination
 resulting from application of facially neutral policies that have a disparate impact
 on the protected classes listed above.
 <br/>
 <br/>
 The United States Department of Housing and Urban Development (“HUD”) oversees
 implementation of the FHA. HUD’s Office of General Counsel has issued guidance
 (the “OGC Guidance”) that use of criminal screening information may have a
 disparate impact on minorities and other protected classes in violation of the FHA.
 The OGC Guidance is available at <a href=“https://www.hud.gov/sites/documents/hud_ogcguidappfhastandcr.pdf”>https://www.hud.gov/sites/documents/hud_ogcguidappfhastandcr.pdf</a>. End User represents and warrants that End User is familiar with the above OGC Guidance and
 will not utilize Background Screening Reports in a discriminatory manner.
 <br/>
 <br/>
 <strong>7. CRIMINAL RECORD PROVISIONS</strong>
 <br/>
 <br/>
 If you access criminal record information through CIC it must meet the
 requirements as defined in the following statutes: Freedom of Information Act, 5
 USC 552; Crime Control Act, Public Law 93-579, 5 USC 522(a), Title 6, Fair Credit
 Reporting Act, Public Law 91-508; and all other state and federal laws governing the
 use of criminal record information.
 <br/>
 <br/>
 <strong>8. POINT OF SALE CERTIFICATION</strong>
 <br/>
 <br/>
 In compliance with Section 1785.14(a) of the California Civil Code, End User certifies
 to CIC that End User is NOT a retail seller, as defined in Section 1802.3 of the
 California Civil Code, and does NOT issue credit to consumers who appear in person
 on the basis of applications for credit submitted in person.
 <br/>
 <br/>
 <strong>9. CONFIDENTIALITY</strong>
 <br/>
 <br/>
 End User acknowledges that a Background Screening Report and/or data provided
 by or received by End User includes Consumer’s non-public personal information, and
 requires that the End User treat such information responsibly, take reasonable steps
 to maintain appropriate confidentiality, and to prevent unlawful dissemination or
 misuse. End User agrees that the Service and Background Screening Report shall
 only be used as expressly authorized in this Agreement. End User agrees that
 under no circumstances will End User sell or otherwise disclose any Background
 Screening Report, or information contained in or derived from it, to any third party
 unless otherwise required by law.
 <br/>
 <br/>
 <strong>10. COMPLIANCE WITH LAWS</strong>
 <br/>
 <br/>
 End User agrees to and shall comply with all federal, state and local laws, rules,
 regulations and decisions applicable to your provision to CIC of data and your use
 of the Background Screening Report and Service provided under this Agreement,
 including all relevant federal, state and municipal statutes and regulations where
 the rental property is located. CIC, in its sole discretion, may not include certain
 housing court and/or criminal records from the Background Screening Report to
 comply with the applicable federal, state, or local laws, regulations or ordinances,
 and in accordance with CIC’s policies and procedures.
 <br/>
 <br/>
 <strong>11. FEES</strong>
 <br/>
 <br/>
 No fees are charged by CIC to the Consumer or End User for use of the Service.
 Any fees for using the Service, if applicable, will be collected through the Service
 Website, not by CIC.
 <br/>
 <br/>
 <strong>12. MODIFICATION OR TERMINATION OF SERVICE</strong>
 <br/>
 <br/>
 CIC may, in its sole discretion, modify or discontinue any Service or Content, or any
 portion thereof, with or without notice. You agree that CIC will not be liable to you or
 any third party for any modification or discontinuance of any Service or Content.
 <br/>
 <br/>
 <strong>13. UPDATED TERMS OF USE</strong>
 <br/>
 <br/>
 This Agreement may be updated from time to time. You agree to review the
 current updates to these Terms of Use, as applicable. Each time you order,
 access or use any Service, and/or Content, you signify your acceptance and
 agreement, without limitation or qualification, to be bound by the then current
 Agreement.
 <br/>
 <br/>
 <strong>14. TERMINATION OF AGREEMENT</strong>
 <br/>
 <br/>
 This Agreement may be terminated without cause by CIC at any time upon notice by
 email to you. The email address for notice will be the then current email address in
 your account profile.
 <br/>
 <br/>
 <strong>15. NOTICE OF PROSECUTION</strong>
 <br/>
 <br/>
 Access to and use of any secure areas of the Service, including those accessed
 through the Service Website, is restricted to authorized users only. Unauthorized
 individuals attempting to access these areas of the Service may be subject to
 prosecution.
 <br/>
 <br/>
 <strong>16. SECURITY MEASURES AND AUTHENTICATION</strong>
 <br/>
 <br/>
 Because CIC uses security measures designed to protect your privacy and to
 safeguard your information, CIC may not always be able to successfully provide a
 Service to you. For example, when the system is unable to verify your identity, CIC
 may be unable to fulfill your order.
 <br/>
 <br/>
 By executing this Agreement, you acknowledge you have reviewed the Access
 Security Requirements at <a href=“https://www.cicreports.com/Access-Security-Requirements”>https://www.cicreports.com/Access-Security-Requirements</a>
 and will take all reasonable measures to comply.
 <br/>
 <br/>
 <strong>17. PERSONAL INFORMATION</strong>
 <br/>
 <br/>
 CIC may use your personal information in connection with the Service and as allowed
 by CIC’s Privacy Policy. CIC’s Privacy Policy is available
 at www.cicreports.com/privacy-policy. You may also request a copy of CIC’s Privacy
 Policy by contacting us at compliance@CICReports.com.
 <br/>
 <br/>
 <strong>18. REVIEW AND RECEIPT OF PRIVACY NOTICE</strong>
 <br/>
 <br/>
 By executing this Agreement, you acknowledge you have reviewed CIC’s Privacy
 Policy and agree to its terms.
 <br/>
 <br/>
 <strong>19. ON-LINE REQUIREMENTS</strong>
 <br/>
 <br/>
 By agreeing to these Terms of Use, you are agreeing to CIC’s Consent to
 Electronic Signature and Disclosures (available
 at <a href=“https://www.cicreports.com/electronic-consent-policy/”>https://www.cicreports.com/electronic-consent-policy/</a>). You are agreeing
 that you have an email address. You are agreeing to receive all notifications via
 email at the email address on file with Zillow®. To ensure receipt of all
 notifications, you are obligated to update the email address on file when your
 email address changes. By accepting these Terms of Use, you are further agreeing that you:
 <br/>
 <br/>
 ● HAVE READ AND UNDERSTAND CIC’S ESIGN POLICIES DESCRIBED IN THIS CONSENT;
 <br/>
 ● CONSENT TO USING ELECTRONIC SIGNATURES;
 <br/>
 ● AGREE TO HAVING ALL COMMUNICATIONS PROVIDED OR MADE AVAILABLE TO YOU IN ELECTRONIC FORM;
 <br/>
 ● MAY REQUEST A PAPER COPY OF THE ELECTRONIC RECORDS; AND
 <br/>
 ● MAY WITHDRAW YOUR CONSENT AT ANY TIME.
 <br/>
 <br/>
 <strong>20. CALIFORNIA INVESTIGATIVE CONSUMER REPORTING AGENCIES ACT (ICRAA)</strong>
 <br/>
 <br/>
 In addition to compliance with Section 4 (FCRA Certifications), End User, in its
 request for and use of the Service constituting an Investigative Consumer Report
 under ICRAA, will comply with all obligations under ICRAA and the California
 Investigative Consumer Reporting Agencies Act Policy (“ICRAA”). ICRAA regulates
 the use of “investigative consumer reports” (as defined by ICRAA CA Civ Code
 1786) for rental property decisions where the consumer is located in California or
 the rental property is located in California (as further defined by ICRAA) or the
 rental decision is made in California. End User’s continued use of these reports
 constitutes End User’s explicit agreement to comply with ICRAA, as well as End
 User’s compliance with legal obligations under the Agreement.
 <br/>
 <br/>
 End User certifies to CIC that End User has or will make, in accordance with ICRAA,
 all applicable disclosures required in the ICRAA and in California Civil Code
 §1786.16, subdivision (a) and End User shall comply with subdivision (b). For ease,
 the requirements of subdivision (b), as in effect as of the Revised date above, are
 set forth below. As used in this section, Investigative Consumer Report means an
 Investigative Consumer Report as defined under ICRAA.
 <br/>
 <br/>
 End User shall:
 <br/>
 <br/>
 (a) provide the consumer a means by which the consumer may indicate on a
 written form, by means of a box to check, that the consumer wishes to receive a
 copy of any Investigative Consumer Report that is prepared. If the consumer
 wishes to receive a copy of the Investigative Consumer Report, End User shall
 send a copy of the Investigative Consumer Report to the consumer within three
 business days of the date that the Investigative Consumer Report is provided to
 End User by CIC. The notice to request the Investigative Consumer Report may be
 contained on either the disclosure form, as required by subdivision (a), or a
 separate consent form. The copy of the Investigative Consumer Report shall
 contain the name, address, and telephone number of CIC as the issuer of the
 Investigative Consumer Report and how to contact CIC with respect to
 Investigative Consumer Reports;
 <br/>
 <br/>
 (b) comply with California Civil Code §1786.40, if End User takes adverse action
 against the consumer for which the Investigative Consumer Report relates.
 Specifically, End User acknowledges and agrees to provide to consumers for
 whom an Investigative Consumer Report is provided, and in the adverse action
 cases, to include the contact information below for CIC as provided by CIC to End
 User;
 <br/>
 <br/>
 (c) limit its provision of the CIC contact information to a Consumer for whom End
 User has received an Investigative Consumer Report; and the contact information
 for CIC is below:
 <br/>
 <br/>
 Contemporary Information Corp.
 3700 Crestwood Pkwy, Suite 300
 Duluth, GA 30096
 Toll Free number - (888) 316-4242
 Toll Free fax - (888) 797-2254
 <a href=“https://www.cicreports.com/consumer-assistance/”>https://www.cicreports.com/consumer-assistance/</a>
 <br/>
 <br/>
 <strong>21. NOT A CREDIT REPAIR ORGANIZATION OR CONTRACT</strong>
 <br/>
 <br/>
 CIC is not acting as a credit repair organization when providing Consumer with
 the Service, and is not offering to sell, provide or perform any service to Consumer
 for the express or implied purpose of either improving Consumer’s credit record,
 credit history or credit rating or providing advice or assistance to Consumer with
 regard to improving Consumer’s credit record, credit history or credit rating.
 Consumer acknowledges and agrees that Consumer is not seeking to purchase,
 use, or access any of the Service, Service Website, and Content in order to do so.
 <br/>
 <br/>
 <strong>22. NO WARRANTY BY CIC</strong>
 <br/>
 <br/>
 REPORT SUBJECT ACKNOWLEDGES THAT THE INFORMATION PROVIDED TO
 CONSUMER THROUGH THE REPORT SERVICE, AND THE CONSUMER’S
 BACKGROUND SCREENING REPORT, MAY CHANGE OVER TIME AS CONSUMER’S
 REPORT CHANGES. YOU EXPRESSLY UNDERSTAND AND AGREE THAT YOUR USE
 OF THE SERVICE, SERVICE WEBSITE AND CONTENT IS AT YOUR SOLE RISK. ALL
 SERVICE, SERVICE WEBSITE AND CONTENT ARE PROVIDED ON AN “AS IS” OR “AS
 AVAILABLE” BASIS. CIC, ITS SUPPLIERS, AND ITS DATA PROVIDERS EXPRESSLY
 DISCLAIM ALL WARRANTIES, GUARANTEES AND CONDITIONS OF ANY KIND
 WHETHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO, THE IMPLIED
 WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE
 OR NONINFRINGEMENT. THE INFORMATION CONTAINED IN THE SERVICE,
 SERVICE WEBSITE, CONTENT OR OTHER MATERIALS YOU MAY RECEIVE FROM CIC
 DO NOT CONSTITUTE LEGAL, TAX, ACCOUNTING OR OTHER PROFESSIONAL
 ADVICE. CIC MAKES NO WARRANTY THAT (I) THE SERVICE AND CONTENT ARE
 ACCURATE, TIMELY, UNINTERRUPTED OR ERROR-FREE; AND (II) ANY RESULTS
 THAT MAY BE OBTAINED FROM THE USE OF THE SERVICE OR CONTENT WILL BE
 RELIABLE.
 <br/>
 <br/>
 <strong>23. LIMITATION OF LIABILITY</strong>
 <br/>
 <br/>
 YOU UNDERSTAND AND AGREE THAT CIC WILL NOT BE LIABLE TO YOU FOR ANY
 DIRECT, INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR EXEMPLARY
 DAMAGES RESULTING FROM OR IN ANY WAY CONNECTED TO YOUR ACCESS TO,
 USE OF, OR INABILITY TO USE ANY SERVICE, THE SERVICE WEBSITE OR CONTENT,
 EVEN IF CIC HAS BEEN ADVISED OF THE POSSIBILITY OF THOSE DAMAGES. SOME
 JURISDICTIONS EITHER DO NOT ALLOW OR PLACE RESTRICTIONS UPON THE
 EXCLUSION OR LIMITATION OF DAMAGES IN CERTAIN TYPES OF AGREEMENTS;
 FOR THESE JURISDICTIONS, THE AFOREMENTIONED LIMITATION ON LIABILITY
 SHALL BE TO THE MAXIMUM DEGREE PERMITTED BY APPLICABLE LAW. IF,
 NOTWITHSTANDING THE ABOVE, LIABILITY IS IMPOSED UPON CIC, THEN YOU
 AGREE THAT CIC’S TOTAL LIABILITY TO YOU FOR ANY OR ALL OF YOUR LOSSES OR
 INJURIES FROM CIC’S ACTS OR OMISSIONS, REGARDLESS OF THE NATURE OF THE
 LEGAL OR EQUITABLE CLAIM, SHALL NOT EXCEED THE MONETARY AMOUNT, IF
 ANY, PAID BY THE APPLICABLE REPORT SUBJECT.
 <br/>
 <br/>
 <strong>24. ENTIRE AGREEMENT</strong>
 <br/>
 <br/>
 These Terms of Use, the Privacy Policy, and other policies CIC may post to the
 Service Website constitute the entire Agreement between CIC and Consumer or
 End User in connection with Consumer’s and End User’s use of the Service,
 through the Service Website, and the Content, and supersede any prior versions
 of the Terms of Use, if applicable. The Terms of Use are effective until terminated
 by CIC. In the event of termination, the Intellectual Property, Disclaimers, and
 Limitations of Liability provisions set forth in these Terms of Use will survive, in
 addition to any other provisions of this Agreement that would normally survive
 termination for any reason. In the event of a conflict between any other notice,
 policy, disclaimer or other term contained in the Service Website or otherwise,
 these Terms of Use will control. As set forth in Section 32 herein, if any provision
 is deemed to be unlawful or unenforceable, it will not affect the validity and
 enforceability of the remaining provisions. The foregoing does not apply to
 Section 33(f) of this Agreement; if Section 33(f), or any portion thereof, is found to
 be unenforceable, the arbitration clause (but only the arbitration clause) shall be
 null and void. The section headings are for convenience only and do not have any
 force or effect.
 <br/>
 <br/>
 <strong>25. DATA AND INTELLECTUAL PROPERTY OWNERSHIP</strong>
 <br/>
 <br/>
 Consumer and End User each acknowledge that CIC has expended substantial
 time, effort and funds to create and deliver the Service and compile its various
 databases. All data in CIC’s databases and any other intellectual property that are
 part of the Service are and will continue to be CIC’s exclusive property. Nothing
 contained in this Agreement shall be deemed to convey to Consumer, End User,
 or to any other party any ownership interest in or to intellectual property or data
 provided in connection with the Service.
 CIC does not use Artificial Intelligence (AI) in the collection or hygiene of criminal
 or housing court records.
 <br/>
 <br/>
 <strong>26. TRADEMARKS</strong>
 <br/>
 <br/>
 Consumer and End User acknowledge and agree that the name CIC and CIC Logo,
 and other terms, phrases, graphics, logos, and icons are common law or
 registered trademarks, service marks, and/or trade dress of CIC (collectively
 “Marks”). Consumer and End User agree not to use any such Content or Marks for
 any purpose without CIC’s prior written authorization. CIC’s Marks may not be
 used in connection with any product or service that is not CIC’s, in any manner
 that is likely to cause confusion among customers, or in any manner that
 disparages or discredits CIC. All other trademarks, names, or logos not owned by
 CIC that appear on this Service Website are the property of their respective
 owners.
 <br/>
 <br/>
 <strong>27. WAIVER</strong>
 <br/>
 <br/>
 No failure on the part of either party to enforce any covenant, agreement, or
 condition of this Agreement shall operate as a discharge of such covenant,
 agreement, or condition, or render the same invalid, or impair the right of either
 party to enforce the same in the event of any subsequent breach by the other
 party.
 <br/>
 <br/>
 <strong>28. AUDIT</strong>
 <br/>
 CIC will have the right to audit your use of the Service to assure compliance with
 the terms of this Agreement. You will be responsible for assuring full cooperation
 with CIC in connection with such audits and will provide CIC access to such
 properties and records as CIC may reasonably require for such purpose.
 <br/>
 <br/>
 <strong>29. ASSIGNMENT</strong>
 <br/>
 <br/>
 You acknowledge and agree that CIC may assign or transfer its rights and
 obligations under this Agreement to any third party. Any assignment or transfer
 shall not entitle you to any change in terms or refunds. End User and Consumer
 may not assign or transfer their rights and obligations under this Agreement
 without CIC’s written permission, which may be denied in CIC’s sole discretion.
 <br/>
 <br/>
 <strong>30. GOVERNING LAW</strong>
 <br/>
 <br/>
 The interpretation and enforcement of the arbitration provision contained in
 Section 25 of this Agreement is governed by the Federal Arbitration Act. This
 Agreement shall otherwise be governed by, construed and enforced in
 accordance with the laws of the State of Georgia without giving effect to any
 principles of conflicts of law.
 <br/>
 <br/>
 <strong>31. SEVERABILITY</strong>
 <br/>
 <br/>
 This Agreement shall be deemed to be severable and, if any provision is
 determined to be void or unenforceable, then that provision will be deemed
 severed and the remainder of the Agreement will remain in effect. The foregoing
 does not apply to Section 33(f) of this Agreement; if Section 33(f), or any portion
 thereof, is found to be unenforceable, the arbitration clause (but only the
 arbitration clause) shall be null and void.
 <br/>
 <br/>
 <strong>32. FORCE MAJEURE</strong>
 <br/>
 <br/>
 CIC shall not be liable by reason of any failure or delay in the performance of its
 obligations hereunder due to any reason beyond its reasonable control.
 <br/>
 <br/>
 <strong>33. DISPUTE RESOLUTION BY BINDING ARBITRATION</strong>
 <br/>
 <br/>
 PLEASE READ THIS CAREFULLY. IT AFFECTS YOUR RIGHTS.
 <br/>
 <br/>
 SUMMARY:
 MOST CONSUMER AND END USER CONCERNS CAN BE RESOLVED QUICKLY AND
 TO THE CONSUMER’S OR END USER’S SATISFACTION BY CONTACTING CIC’S
 CUSTOMER SERVICE DEPARTMENT AT COMPLIANCE@CICREPORTS.COM
 REGARDING THE SERVICE, SERVICE WEBSITE OR CONTENT. IN THE UNLIKELY
 EVENT THAT CIC’S CUSTOMER SERVICE DEPARTMENT IS UNABLE TO RESOLVE A
 COMPLAINT CONSUMER OR END USER MAY HAVE TO CONSUMER’S OR END
 USER’S SATISFACTION (OR IF CIC HAS NOT BEEN ABLE TO RESOLVE A DISPUTE IT
 HAS WITH CONSUMER OR END USER AFTER ATTEMPTING TO DO SO
 INFORMALLY), THE PARTIES EACH AGREE TO RESOLVE THOSE DISPUTES
 THROUGH BINDING ARBITRATION INSTEAD OF IN COURTS OF GENERAL
 JURISDICTION TO THE FULLEST EXTENT PERMITTED BY LAW. ARBITRATION IS
 MORE INFORMAL THAN A LAWSUIT IN COURT. ARBITRATION USES A NEUTRAL
 ARBITRATOR INSTEAD OF A JUDGE OR JURY, ALLOWS FOR MORE LIMITED
 DISCOVERY THAN IN COURT, AND IS SUBJECT TO VERY LIMITED REVIEW BY
 COURTS. ANY ARBITRATION UNDER THIS AGREEMENT WILL TAKE PLACE ON AN
 INDIVIDUAL BASIS; CLASS ARBITRATIONS AND CLASS ACTIONS ARE NOT
 PERMITTED. CIC WILL PAY THE CONSUMER’S COSTS OF ARBITRATION, NO
 MATTER WHO WINS, SO LONG AS THE CLAIM IS NOT FRIVOLOUS.
 <br/>
 <br/>
 <strong>Arbitration Agreement:</strong>
 <br/>
 (a) CIC, End User and Consumer each agree to arbitrate all disputes and claims
 against CIC arising out of this Agreement to the maximum extent permitted by
 law, except any disputes or claims which under governing law are not subject to
 arbitration. This agreement to arbitrate is intended to be broadly interpreted and
 to make all disputes and claims between the parties relating to the Service,
 Content, and/or your use of the Service Website subject to arbitration to the
 fullest extent permitted by law. This agreement to arbitrate includes, but is not
 limited to: claims arising out of or relating to any aspect of the relationship
 between CIC, End User, and/or Consumer, arising out of the Service, Service
 Website, or Content, whether based in contract, tort, statute, fraud,
 misrepresentation or any other legal theory, including, but not limited to, claims
 relating to advertising, claims that are currently the subject of purported class
 action litigation in which End User and/or Consumer (as applicable) is not a
 member of a certified class, and claims that may arise after the termination of
 this Agreement.
 For purposes of this arbitration provision, references to “CIC,” “Consumer,” and
 “End User” shall include each party’s respective parent entities, subsidiaries,
 affiliates, agents, employees, predecessors in interest, successors and assigns, as
 well as all authorized or unauthorized users or beneficiaries of Service, Content
 and /or Service Website or information under this or prior Agreements between
 us relating to the Service, Content and/or Service Website.
 <br/>
 <br/>
 Notwithstanding the foregoing, a party may bring an individual action in small
 claims court. Consumer and End User agree that, by entering into this Agreement,
 Consumer, End User, and CIC are each waiving the respective party’s right to a
 trial by jury or to participate in a class action to the maximum extent permitted
 by law. This Agreement evidences a transaction in interstate commerce, and thus
 the Federal Arbitration Act governs the interpretation and enforcement of this
 provision. This arbitration provision shall survive termination of this Agreement.
 <br/>
 <br/>
 More information about arbitration is available from www.adr.org.
 <br/>
 <br/>
 (b) A party who intends to seek arbitration must first send to the other, by certified
 mail, a written Notice of Dispute (“Notice”). The Notice to CIC should be addressed
 to: Attn: Compliance, CIC, 3700 Crestwood Parkway NW, Suite 300, Duluth,
 Georgia 30096 (“Notice Address”). The Notice must (a) describe the nature and
 basis of the claim or dispute; and (b) set forth the specific relief you seek from CIC
 (“Demand”). If CIC and the respective party do not reach an agreement to resolve
 the claim within 30 days after the Notice is received, the party or CIC may
 commence an arbitration proceeding. During the arbitration, the amount of any
 settlement offer made by CIC or you shall not be disclosed to the arbitrator until
 after the arbitrator determines the amount, if any, to which you or CIC is entitled.
 <br/>
 <br/>
 (c) After CIC receives notice at the Notice Address that a Consumer has
 <br/>
 <br/>
 commenced arbitration, CIC will promptly reimburse Consumer for payment of
 the filing fee. (The filing fee currently is $200 for claims under $10,000, but is
 subject to change by the arbitration provider. If Consumer is unable to pay this
 fee, CIC will pay it directly upon receiving a written request at the Notice Address.)
 The arbitration will be governed by the Commercial Dispute Resolution
 Procedures and the Supplementary Procedures for Consumer Related Disputes
 (collectively, “AAA Rules”) of the American Arbitration Association (“AAA”), as
 modified by this Agreement, and will be administered by the AAA. If the AAA is
 unavailable or refuses to arbitrate the parties’ dispute for any reason, the
 arbitration shall be administered and conducted by a widely-recognized
 arbitration organization that is mutually agreeable to the parties, but neither
 party shall unreasonably withhold their consent. If the parties cannot agree to a
 mutually agreeable arbitration organization, one shall be appointed pursuant to
 Section 5 of the Federal Arbitration Act. The applicable forum’s rules shall govern
 the parties’ dispute. The AAA Rules are available online at www.adr.org, by calling
 the AAA at 1-(800) 778-7879, or by writing to the Notice Address. The AAA Rules
 may change from time to time, and you should review them periodically.
 <br/>
 <br/>
 All issues are for the arbitrator to decide, including the scope and enforceability
 of this arbitration provision as well as the Agreement’s other terms of
 use, and the arbitrator shall have exclusive authority to resolve any such
 dispute relating to the scope and enforceability of this arbitration provision or any
 other term of this Agreement including, but not limited to any claim that all or any
 part of this arbitration provision or Agreement is void or voidable. However, if
 putative class or representative claims are initially brought by either party in a
 court of law, and a motion to compel arbitration is brought by any party, then the
 court shall have the power to decide whether this agreement permits class or
 representative proceedings. The arbitrator shall be bound by the terms of this
 Agreement and shall follow the applicable law. In this regard, the arbitrator shall
 not have the power to commit errors of law or legal reasoning, and any award
 rendered by the arbitrator that employs an error of law or legal reasoning may
 be vacated or corrected by a court of competent jurisdiction for any such error.
 Unless CIC and Consumer or End User (as applicable) agree otherwise, any
 arbitration hearings will take place in the county (or parish) of the party’s billing
 address. If a claim is for $10,000 or less, the parties agree that the parties may
 choose whether the final arbitration hearing will be conducted solely on the basis
 of documents submitted to the arbitrator, through a remote hearing, or by an in-person
 hearing as established by the AAA Rules. If a party’s claim exceeds $10,000,
 the right to a hearing will be determined by the AAA Rules. Except as otherwise
 provided for herein, for Consumer-related arbitrations, CIC will pay all AAA filing,
 administration and arbitrator fees for any arbitration initiated in accordance with
 the notice requirements above.
 <br/>
 <br/>
 If the arbitrator finds that either the substance of the Consumer’s or End User’s
 claim or the relief sought in the Demand is frivolous or brought for an improper
 purpose (as measured by the standards set forth in Federal Rule of Civil
 Procedure 11(b)), then the payment of all such fees will be governed by the AAA
 Rules.
 <br/>
 <br/>
 (d) The arbitrator may make rulings and resolve disputes as to the payment and
 reimbursement of fees and expenses at any time during the proceeding or in the
 final award, pursuant to applicable law and the AAA Rules.
 <br/>
 <br/>
 (e) Discovery and/or the exchange of non-privileged information relevant to the
 dispute will be governed by the AAA Rules.
 <br/>
 <br/>
 (f) THE PARTIES AGREE THAT EACH MAY BRING CLAIMS AGAINST THE OTHER ONLY
 IN THE PARTY’S INDIVIDUAL CAPACITY, AND NOT AS A PLAINTIFF OR CLASS
 MEMBER IN ANY PURPORTED CLASS OR REPRESENTATIVE PROCEEDING. Further,
 unless both the party and CIC agree otherwise, the arbitrator may not consolidate
 more than one person’s claims, and may not otherwise preside over any form of
 a representative or class proceeding. The arbitrator may award injunctive relief
 only in favor of the individual party seeking relief and only to the extent necessary
 to provide relief warranted by that party’s individual claim. If this specific
 subparagraph (f) is found to be unenforceable in its entirety, then the entirety of
 this arbitration provision shall be null and void. However, if only a portion of this
 subparagraph (f) is found to be unenforceable, then the unenforceable portion of
 the provision shall be stricken, and the remainder of subparagraph (f) enforced.
 Any claims not subject to individual arbitration under applicable law shall be
 stayed in a court of competent jurisdiction pending completion of the individual
 arbitration.
 <br/>
 <br/>
 (g) Notwithstanding any provision in this Agreement to the contrary, the parties
 agree that if CIC makes any change to this arbitration provision (other than a
 change to the Notice Address) during your membership in the Service, or
 subsequent to your purchase of the Service, you may reject any such change and
 require CIC to adhere to the language in this provision as written at the time of
 your enrollment or purchase if a dispute between us arises regarding such Service
 by providing Notice to CIC at the Notice Address above prior to initiating your
 dispute.
 <br/>
 <br/>
 BY CLICKING THE “Read and accept CIC Terms of Use” BUTTON,
 CONSUMER OR END USER (AS APPLICABLE THROUGHOUT THIS PARAGRAPH)
 ACKNOWLEDGE THAT CONSUMER OR END USER HAS READ AND AGREED TO THE
 TERMS OF THIS AGREEMENT, INCLUDING THE ARBITRATION PROVISION
 CONTAINED IN SECTION 33 ENTITLED “DISPUTE RESOLUTION BY BINDING
 ARBITRATION,” AND CONSENT TO THIS BINDING ELECTRONIC TRANSACTION.
 CONSUMER AND END USER FURTHER AGREE THAT CONSUMER’S OR END USER’S
 AUTHORIZED REPRESENTATIVE’S ELECTRONIC SIGNATURE IS EFFECTIVE AND
 CONSUMER AND END USER WILL NOT CONTEST THE LEGALLY BINDING NATURE,
 VALIDITY OR ENFORCEABILITY OF THIS AGREEMENT, INCLUDING THE
 ARBITRATION PROVISION CONTAINED IN SECTION 33, BASED ON THE FACT THAT
 THE TERMS WERE ACCEPTED ELECTRONICALLY. CONSUMER AND END USER
 FURTHER ACKNOWLEDGE AND AGREE THAT CONSUMER AND END USER MAY
 RECEIVE RELATED NOTICES AND OTHER SERVICES ELECTRONICALLY
 THROUGHOUT CONSUMER’S OR END USER’S ENTIRE COURSE OF PARTICIPATION
 IN THE SERVICE.
 <br/>
 <br/>
 This Agreement and any related transactions entered into electronically will be
 deemed to be “in writing” and to have been “signed” by Consumer or End User
 (as applicable) with the same effect as a manual signature (and any electronic
 record of such Agreement entered into online will be deemed to be “in writing.”)
 <br/>
 <br/>
 The individual agreeing to these Terms of Use acknowledges that he or
 she has a printer or other device to print or save this Agreement. After clicking
 “Read and accept CIC Terms of Use”, Consumer or End User may contact
 CIC at compliance@CICReports.com to obtain a paper copy of this Agreement or
 any other electronic record provided as part of the Service. The provision of
 certain records in paper form may be subject to additional fees. In addition, the
 individual agreeing to these Terms of Use may withdraw the individual’s
 consent to conduct transactions electronically by contacting CIC
 at compliance@CICReports.com, though doing so will act as a notice of
 termination of this Agreement. Consumer and End User are required to maintain
 current contact information with CIC at all times Consumer or End User is utilizing
 the Service Website.
 <br/>
 <br/>
 Updated 10-13-2025 
</p>
`;
export default CicTacNew;
